import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BackButton } from "@/components/ui/back-button";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Smartphone, Bell, CheckCircle } from "lucide-react";

const AndroidWaitlist = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-2xl mx-auto pt-16">
        <div className="fixed top-4 left-4 z-50">
          <BackButton onClick={() => navigate(-1)} />
        </div>

        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary/10 mb-6">
            <Smartphone className="w-10 h-10 text-primary" />
          </div>
          <h1 className="text-4xl font-bold mb-4">{t('android_waitlist.title')}</h1>
          <p className="text-lg text-muted-foreground">
            {t('android_waitlist.desc')}
          </p>
        </div>

        <div className="text-center mb-8">
        </div>

        <Card className="p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
            <Bell className="w-5 h-5 text-primary" />
            {t('android_waitlist.features_title')}
          </h2>
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('android_waitlist.feature_parity')}</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('android_waitlist.feature_google_fit')}</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('android_waitlist.feature_native')}</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('android_waitlist.feature_sync')}</span>
            </li>
          </ul>
        </Card>

        <Card className="p-6 text-center">
          <h2 className="text-xl font-semibold mb-4">{t('android_waitlist.notify_title')}</h2>
          <p className="text-muted-foreground mb-4">
            {t('android_waitlist.notify_desc')}
          </p>
          <Button
            onClick={() => navigate('/contact-us')}
            className="w-full sm:w-auto"
          >
            <Bell className="w-4 h-4 mr-2" />
            {t('android_waitlist.join_waitlist')}
          </Button>
        </Card>

        <div className="mt-8 text-center">
          <p className="text-sm text-muted-foreground">
            {t('android_waitlist.web_note')}{' '}
            <a href="/" className="text-primary hover:underline">gitfit.ai</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AndroidWaitlist;
